<template>
  <BaseGridCardVertical
    v-bind="$attrs"
    class="base-product-grid-card"
    v-on="$listeners"
  >
    <template v-slot:body>
      <slot name="image">
        <BaseImage
          v-if="imageSrc"
          :alt="imageAlt"
          :aspect-ratio="imageAspectRatio"
          :src="imageSrc"
          class="base-product-grid-card__image"
          :placeholder-color-background="placeholderColorBackground"
          :placeholder-color-foreground="placeholderColorForeground"
        />
      </slot>

      <slot name="meta-text">
        <v-card-text
          v-if="metaText"
          :class="[
            'base-product-grid-card__meta-text',
            'pt-4 pb-0',
            'overline',
            metaTextColor,
          ]"
        >
          {{ metaText }}
        </v-card-text>
      </slot>

      <slot name="title-text">
        <v-card-text
          v-if="titleText"
          style="line-height: 1.3;"
          :class="[
            'base-product-grid-card__title-text',
            'pt-4 mb-3 text-line-clamp-2',
            'title',
            titleTextColor,
          ]"
        >
          {{ titleText }}
        </v-card-text>
      </slot>
    </template>

    <template v-slot:footer>
      <slot name="footer">
        <v-card-actions
          v-if="footerText
            || wishlistShow
            || $slots['footer-text']
            || $slots['footer-wishlist']
          "
          :class="[
            'base-product-grid-card__footer',
            'pt-0 body-2',
          ]"
        >
          <slot name="footer-text">
            <span
              v-if="footerText"
              :class="[
                'base-product-grid-card__footer-text',

                // Using v-btn for it's dimensions within v-card-actions
                'v-btn v-btn--text v-size--default reset-btn-text',
                footerTextColor,
              ]"
            >
              {{ footerText }}
            </span>
          </slot>

          <template v-if="wishlistShow">
            <slot name="footer-wishlist">
              <v-spacer />

              <v-tooltip bottom>
                <template v-slot:activator="{ on }">
                  <!-- TODO: Abstract to Component as "working" button -->
                  <v-btn
                    class="base-product-grid-card__wishlist-btn"
                    :disabled="!$listeners.wishlistClick || wishlistLoading"
                    icon
                    :loading="wishlistLoading"
                    v-on="on"
                    @click.prevent="emitWishlistClick"
                  >
                    <v-icon
                      class="base-product-grid-card__wishlist-icon"
                      :color="wishlistIconColor"
                    >
                      mdi-{{ wishlist ? wishlistIcon : `${wishlistIcon}-outline` }}
                    </v-icon>
                  </v-btn>
                </template>

                <span class="base-product-grid-card__wishlist-tooltip">
                  {{ wishlist ? wishlistTextRemove : wishlistTextAdd }}
                </span>
              </v-tooltip>
            </slot>
          </template>
        </v-card-actions>
      </slot>
    </template>
  </BaseGridCardVertical>
</template>

<script>
import BaseGridCardVertical from "../../baseGridCardVertical/components/BaseGridCardVertical";
import BaseImage from "../../baseImage/components/BaseImage";

export default {
  name: "BaseProductGridCard",

  components: {
    BaseGridCardVertical,
    BaseImage,
  },

  props: {
    footerText: {
      type: String,
      default: undefined,
    },

    footerTextColor: {
      type: String,
      default: undefined,
    },

    height: {
      type: [String, Number],
      default: "100%",
    },

    imageAlt: {
      type: String,
      default: "Image of product",
    },

    imageAspectRatio: {
      type: [
        String,
        Number,
      ],
      default: 1.7778, // 16:9
    },

    imagePlaceholderColor: {
      type: String,
      default: undefined,
    },

    imageSrc: {
      type: String,
      default: undefined,
    },

    metaText: {
      type: String,
      default: undefined,
    },

    metaTextColor: {
      type: String,
      default: undefined,
    },

    titleText: {
      type: String,
      default: undefined,
    },

    titleTextColor: {
      type: String,
      default: undefined,
    },

    wishlist: {
      type: Boolean,
    },

    wishlistIcon: {
      type: String,
      default: "heart",
    },

    wishlistIconColor: {
      type: String,
      default: undefined,
    },

    wishlistTextAdd: {
      type: String,
      default: "Add to your Wishlist",
    },

    wishlistTextRemove: {
      type: String,
      default: "Remove from your Wishlist",
    },

    wishlistShow: {
      type: Boolean,
    },
  },

  data() {
    return {
      wishlistLoading: false,
    };
  },

  computed: {
    placeholderColorBackground() {
      return this.imagePlaceholderColor ?
        `${this.imagePlaceholderColor} darken-4` : undefined;
    },

    placeholderColorForeground() {
      return this.imagePlaceholderColor ?
        `${this.imagePlaceholderColor} darken-2` : undefined;
    },
  },

  watch: {
    wishlist() {
      // Parent has update wishlist.
      this.wishlistLoading = false;
    },
  },

  methods: {
    emitWishlistClick() {
      // Load until parent has update wishlist.
      this.wishlistLoading = true;

      this.$emit("wishlistClick");
    },
  },
};
</script>

<style lang="scss" scoped>
.reset-btn-text {
  justify-content: start;
  text-transform: none;
}
</style>
